/* Raghu 27/10/2022 3225736869 Card Styling Fixes */
import React, {useEffect} from 'react';
import NightJobForm from './NightJobForm';
import {useDispatch} from 'react-redux';
import {resetData} from '../../../../../redux/reducers/BRE/AddRuleGroup';

function NightJob({roleDataNJobs, setValue, setTabValue, nightJobCode, setNightJobCode, isCopyRowData}) {
  const dispatch = useDispatch();
  useEffect(
    () => () => {
      dispatch(resetData());
      setNightJobCode('');
    },
    [],
  );

  return (
    <div className={`mb-0`}>
      <NightJobForm roleDataNJobs={roleDataNJobs} setValue={setValue} setTabValue={setTabValue} nightJobCode={nightJobCode} isCopyRowData={isCopyRowData}/>
    </div>
  );
}

export default NightJob;
